import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";

import { buildSignalsRequestParamsForAllOrInverse } from "../helpers";
import * as a from "./action-creators";
import { selectSignalsUse } from "./selectors";

export const fetchSignalsForCountryThunkAction =
    (workspaceId: string, opportunitiesListId: string, countryCode: number) =>
    async (dispatch: ThunkDispatchCommon, getState: ThunkGetState, d: ThunkDependencies) => {
        dispatch(a.fetchSignalsAsyncAction.request());

        try {
            const response = await d.si.api.workspaceSignals.fetchSignals({
                countryCode,
                workspaceId,
                opportunitiesListId,
            });

            dispatch(a.fetchSignalsAsyncAction.success(response));
        } catch (e) {
            dispatch(a.fetchSignalsAsyncAction.failure(e));
        }
    };

export const fetchSignalsForAllOrInverseThunkAction =
    (workspaceId: string, opportunitiesListId: string, countryCode: number) =>
    async (dispatch: ThunkDispatchCommon, getState: ThunkGetState, d: ThunkDependencies) => {
        const userHasOnlyOneCountry = d.si.settingsHelper.hasSingleCountryAllowed();
        const params = buildSignalsRequestParamsForAllOrInverse(
            {
                workspaceId,
                opportunitiesListId,
            },
            countryCode,
            userHasOnlyOneCountry,
        );

        try {
            const response = await d.si.api.workspaceSignals.fetchSignals(params);

            dispatch(a.fetchRestCountriesSignalsSuccessAction(response));
        } catch (e) {
            dispatch(a.fetchSignalsAsyncAction.failure(e));
        }
    };

export const removeListIdFromSignalsUseThunkAction =
    (id: string) => (dispatch: ThunkDispatchCommon, getState: ThunkGetState) => {
        const signalsUse = selectSignalsUse(getState());

        if (Object.keys(signalsUse).includes(id)) {
            const newSignalUse = { ...signalsUse };

            delete newSignalUse[id];

            dispatch(a.getSignalsUseAsyncAction.success(newSignalUse));
        }
    };
